import { useCallback, useEffect, useState } from "react";
import { RefreshCw, Save } from "lucide-react";
import { api, errText } from "../../lib/api";

export const ClaudeModelSelect = ({ value, onChange, testid, disabled = false, saveDefault = false, refreshKey = "", onSaved }) => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const load = useCallback(async (refresh = false) => {
    setBusy(true); setError("");
    try { setData((await api.get("/admin/seo/ai/models", { params: { refresh } })).data); }
    catch (e) { setError(errText(e)); }
    finally { setBusy(false); }
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);
  const save = async () => {
    setBusy(true); setError(""); setMessage("");
    try {
      const { data: saved } = await api.put("/admin/seo/ai/model", { model: value || data?.default_model });
      setData(d => ({ ...d, default_model: saved.model }));
      setMessage("Default saved."); onSaved?.(saved);
    } catch (e) { setError(errText(e)); }
    finally { setBusy(false); }
  };
  return <div className="space-y-1 min-w-0" data-testid={`${testid}-control`}>
    <label htmlFor={`${testid}-select`} className="smallcaps block">Claude model</label>
    <div className="flex flex-wrap items-center gap-2">
      <select id={`${testid}-select`} data-testid={`${testid}-select`} className="field text-xs w-full sm:max-w-sm min-w-0" value={value || ""} disabled={disabled || busy} onChange={e => { onChange(e.target.value); setMessage(""); }}>
        <option value="">{data?.default_model ? `Default · ${data.default_model}` : "Default"}</option>
        {value && !data?.models?.some(m => m.id === value) && <option value={value}>{value}</option>}
        {(data?.models || []).map(m => <option key={m.id} value={m.id}>{`${m.name} · ${m.id}`}</option>)}
      </select>
      <button type="button" className="btn-ghost p-2" title="Refresh Claude models" aria-label="Refresh Claude models" disabled={busy || disabled} onClick={() => load(true)} data-testid={`${testid}-refresh`}><RefreshCw size={15} className={busy ? "animate-spin" : ""} /></button>
      {saveDefault && <button type="button" className="btn-ghost text-xs px-3 inline-flex gap-2 items-center" disabled={busy || disabled || !data?.models?.length} onClick={save} data-testid={`${testid}-save-default`}><Save size={14} /> Save default</button>}
    </div>
    {error && <p role="alert" className="text-xs text-danger break-words" data-testid={`${testid}-error`}>{error}</p>}
    {message && <p role="status" className="text-xs text-success" data-testid={`${testid}-message`}>{message}</p>}
  </div>;
};